import { Injectable } from '@angular/core';

import * as OT from '@opentok/client';
import config from '../config';

import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class OpentokService {
  private endpoint = config.API_VIDEO_SERVER;

  session: OT.Session;
  token: string;

  sessionData: any;
  recordingSession: boolean;

  public get userConfig(): any {
    return this.sessionData.Session.Permissions.Config;
  }
  public get userData(): any {
    return this.sessionData.Session.UserData;
  }

  constructor() {
    const host = window.location.host;
    if (['localhost', 'pre.video.videoconsulta.io'].some(e => host.includes(e))) {
      this.endpoint = config.API_VIDEO_SERVER_PRE;
    }
  }

  getOT() {
    return OT;
  }

  initSession(sess: string): Promise<OT.Session> {
    if (config.API_KEY && config.TOKEN && config.SESSION_ID) { // Legacy only
      this.session = this.getOT().initSession(config.API_KEY, config.SESSION_ID);
      this.token = config.TOKEN;
      return Promise.resolve(this.session);
    } else {
      return fetch(this.endpoint + '/participants/' + sess + '/getSession')
        .then((data) => data.json())
        .then((json) => {
          this.sessionData = json;
          this.sessionData.Session.Hash = sess;
          this.session = this.getOT().initSession(json.Session.ApiKey, json.Session.Id);
          this.token = json.Session.Token;
          this.recordingSession = false;
          return this.session;
        }
        );
    }
  }

  public startArchive(): Promise<boolean> {
    this.recordingSession = true;
    return fetch(this.endpoint + '/participants/' + this.sessionData.Session.Hash + '/startArchive', {
      method: 'POST',
      body: JSON.stringify({ Type: "video" })
    }).then((data) => data.json())
      .then((json) => {
        return json.Success;
      }
      ).catch(() => false);
  }

  public stopArchive(): Promise<boolean> {
    this.recordingSession = false;
    return fetch(this.endpoint + '/participants/' + this.sessionData.Session.Hash + '/stopArchive')
      .then((data) => data.json())
      .then((json) => {
        return json.Success;
      }
      ).catch(() => false);
  }

  public submitImgData(img: string): Promise<boolean> {
    return fetch(this.endpoint + '/participants/' + this.sessionData.Session.Hash + '/uploadImage', {
      method: 'POST',
      body: JSON.stringify({ Type: "image/png;base64", Data: img })
    }).then((data) => data.json())
      .then((json) => {
        return json.Success;
      }
      ).catch(() => false);
  }

  public submitLocationData(data: { Lat: number, Long: number, Accuracy: number }): Promise<boolean> {
    return fetch(this.endpoint + '/participants/' + this.sessionData.Session.Hash + '/uploadLocation', {
      method: 'POST',
      body: JSON.stringify({ Location: data })
    }).then((data) => data.json())
      .then((json) => {
        return json.Success;
      }
      ).catch(() => false);
  }

  connect() {
    return new Promise((resolve, reject) => {
      this.session.connect(this.token, (err) => {
        if (err) {
          reject(err);
        } else {
          resolve(this.session);
        }
      });
    });
  }

  hasPermission(perm: string) {
    return this.sessionData.Session.Permissions.Grant.includes(perm);
  }

  playAudio(sound: string) {
    let audio = new Audio();
    audio.src = "/assets/audio/" + sound + ".mp3";
    audio.load();
    audio.play();
  }

}